module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tab"
  }, [_c('wb-datatable', _vm._b({
    staticClass: "apps-table",
    attrs: {
      "customControls": [{
          icon: 'add',
          name: 'Register at baas',
          handler: function (row) {
            _vm.openAdditionalDialog(row, 'baas');
          }
        },
        {
          icon: 'add',
          name: 'Register audience',
          handler: function (row) {
            _vm.registerAudienceVert(row);
          }
        },
        {
          icon: 'delete',
          name: 'Delete audience',
          handler: function (row) {
            _vm.deleteAudienceVert(row);
          }
        } ],
      "searchKey": 'Name'
    },
    on: {
      "addEmit": _vm.openDialog,
      "editEmit": _vm.openDialog,
      "deleteEmit": _vm.openConfirmDialog
    }
  }, 'wb-datatable', _vm.tableAppProps, false)), _vm._v(" "), _c('md-dialog', {
    ref: "algDialog"
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create algorithm' : 'Update algorithm'))]), _vm._v(" "), _c('md-dialog-content', [_c('form')])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog"
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create app' : 'Update app'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.app) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": !_vm.createNewAppGroup
    },
    model: {
      value: (_vm.app.Name),
      callback: function($$v) {
        _vm.$set(_vm.app, "Name", $$v)
      },
      expression: "app.Name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": !_vm.createNewAppGroup
    },
    model: {
      value: (_vm.app.Category),
      callback: function($$v) {
        _vm.$set(_vm.app, "Category", $$v)
      },
      expression: "app.Category"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Image")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "disabled": !_vm.createNewAppGroup
    },
    model: {
      value: (_vm.app.image),
      callback: function($$v) {
        _vm.$set(_vm.app, "image", $$v)
      },
      expression: "app.image"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("URL")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.app.url),
      callback: function($$v) {
        _vm.$set(_vm.app, "url", $$v)
      },
      expression: "app.url"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Environment")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "environments",
      "options": _vm.environments,
      "placeholder": "Select environment"
    },
    model: {
      value: (_vm.app.environment),
      callback: function($$v) {
        _vm.$set(_vm.app, "environment", $$v)
      },
      expression: "app.environment"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-switch', {
    attrs: {
      "id": "createNewAppGroup"
    },
    model: {
      value: (_vm.createNewAppGroup),
      callback: function($$v) {
        _vm.createNewAppGroup = $$v
      },
      expression: "createNewAppGroup"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "createNewAppGroup"
    }
  }, [_vm._v("Create new App Group")])], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
    attrs: {
      "id": "app-groups",
      "options": _vm.appGroups,
      "label": 'Name',
      "disabled": _vm.createNewAppGroup,
      "placeholder": "Select App Group"
    },
    model: {
      value: (_vm.selectedAppGroup),
      callback: function($$v) {
        _vm.selectedAppGroup = $$v
      },
      expression: "selectedAppGroup"
    }
  })], 1), _vm._v(" "), (!_vm.isNew) ? _c('md-input-container', [_c('label', [_vm._v("Audience ID")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.app.audienceId),
      callback: function($$v) {
        _vm.$set(_vm.app, "audienceId", $$v)
      },
      expression: "app.audienceId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('md-input-container', [_c('label', [_vm._v("Audience Parameter")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.app.audienceParameter),
      callback: function($$v) {
        _vm.$set(_vm.app, "audienceParameter", $$v)
      },
      expression: "app.audienceParameter"
    }
  })], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.app && _vm.app.registerBaas && _vm.baasValidMessage && Object.keys(_vm.baasValidMessage).length > 0
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update') + "\n            ")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "confirmDialog"
  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this app?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n            App will permanently be removed from the database. "), _c('br'), _vm._v(" "), (_vm.app && _vm.app.audienceId) ? [_vm._v("\n                Would you like to remove an audience?\n                "), _c('md-switch', {
    attrs: {
      "id": "delete-audience",
      "name": "delete-audience"
    },
    model: {
      value: (_vm.deleteAnAudience),
      callback: function($$v) {
        _vm.deleteAnAudience = $$v
      },
      expression: "deleteAnAudience"
    }
  }, [_vm._v("Delete an\n                    audience\n                ")])] : _vm._e()], 2), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(true)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "baasDialog"
  }, [_c('md-dialog-title', [_vm._v("Register baas algorithm")]), _vm._v(" "), _c('md-dialog-content', [(_vm.app) ? _c('form', [
    [_c('md-input-container', [_c('label', [_vm._v("Select algorithm")]), _vm._v(" "), _c('md-select', {
      on: {
        "change": _vm.algorithmSelected
      },
      model: {
        value: (_vm.algorithm),
        callback: function($$v) {
          _vm.algorithm = $$v
        },
        expression: "algorithm"
      }
    }, _vm._l((_vm.baasAlgorithms), function(algorithm) {
      return _c('md-option', {
        attrs: {
          "value": algorithm
        }
      }, [_vm._v(_vm._s(algorithm.name) + "\n                            ")])
    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.name) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.name))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "disabled": !!_vm.algorithm
      },
      model: {
        value: (_vm.newAlgData.name),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "name", $$v)
        },
        expression: "newAlgData.name"
      }
    })], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.category) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.category))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Select category")]), _vm._v(" "), _c('md-select', {
      attrs: {
        "disabled": !!_vm.algorithm && _vm.newAlgData.category
      },
      model: {
        value: (_vm.newAlgData.category),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "category", $$v)
        },
        expression: "newAlgData.category"
      }
    }, _vm._l((_vm.baasCategories), function(cat) {
      return _c('md-option', {
        attrs: {
          "value": cat
        }
      }, [_vm._v(_vm._s(cat.name))])
    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.service) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.service))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Select Maas service")]), _vm._v(" "), _c('md-select', {
      on: {
        "change": _vm.maasServiceSelect
      },
      model: {
        value: (_vm.newAlgData.service),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "service", $$v)
        },
        expression: "newAlgData.service"
      }
    }, _vm._l((_vm.services), function(service) {
      return _c('md-option', {
        attrs: {
          "value": service
        }
      }, [_vm._v(_vm._s(service.name))])
    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.environment) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.environment))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Select environment")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.newAlgData.environment),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "environment", $$v)
        },
        expression: "newAlgData.environment"
      }
    }, _vm._l((_vm.baasEnvs), function(env) {
      return _c('md-option', {
        attrs: {
          "value": env
        }
      }, [_vm._v(_vm._s(env.name))])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "multiselect-container"
    }, [(_vm.baasValidMessage && _vm.baasValidMessage.protocol) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.protocol))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Protocol")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.newAlgData.protocol),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "protocol", $$v)
        },
        expression: "newAlgData.protocol"
      }
    }, _vm._l((_vm.protocols), function(protocol) {
      return (_vm.protocols) ? _c('md-option', {
        attrs: {
          "value": protocol.tag
        }
      }, [_vm._v("\n                                " + _vm._s(protocol.name) + "\n                            ")]) : _vm._e()
    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.invocationType) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.invocationType))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Invocation Type")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.newAlgData.invocationType),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "invocationType", $$v)
        },
        expression: "newAlgData.invocationType"
      }
    }, _vm._l((_vm.invocationTypes), function(invocationType) {
      return (_vm.invocationTypes) ? _c('md-option', {
        attrs: {
          "value": invocationType.tag
        }
      }, [_vm._v(_vm._s(invocationType.name) + "\n                            ")]) : _vm._e()
    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.platform) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.platform))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Platform")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.newAlgData.platform),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "platform", $$v)
        },
        expression: "newAlgData.platform"
      }
    }, _vm._l((_vm.platforms), function(platform) {
      return (_vm.platforms) ? _c('md-option', {
        attrs: {
          "value": platform.tag
        }
      }, [_vm._v("\n                                " + _vm._s(platform.name) + "\n                            ")]) : _vm._e()
    }), 1)], 1), _vm._v(" "), _c('md-input-container', [(_vm.baasValidMessage && _vm.baasValidMessage.region) ? _c('p', {
      staticClass: "validation-error"
    }, [_vm._v("\n                            " + _vm._s(_vm.baasValidMessage.region))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Region")]), _vm._v(" "), _c('md-select', {
      model: {
        value: (_vm.newAlgData.region),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "region", $$v)
        },
        expression: "newAlgData.region"
      }
    }, _vm._l((_vm.regionsForPlatforms), function(regionForPlatform) {
      return (_vm.regionsForPlatforms) ? _c('md-option', {
        attrs: {
          "value": regionForPlatform.tag
        }
      }, [_vm._v("\n                                " + _vm._s(regionForPlatform.name) + "\n                            ")]) : _vm._e()
    }), 1)], 1), _vm._v(" "), _c('md-switch', {
      attrs: {
        "id": "report-in-slack",
        "name": "report-in-slack"
      },
      model: {
        value: (_vm.newAlgData.reportInSlack),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "reportInSlack", $$v)
        },
        expression: "newAlgData.reportInSlack"
      }
    }, [_vm._v("\n                        Report In Slack\n                    ")]), _vm._v(" "), _c('md-switch', {
      attrs: {
        "id": "log-problem",
        "name": "log-problem"
      },
      model: {
        value: (_vm.newAlgData.logProblem),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "logProblem", $$v)
        },
        expression: "newAlgData.logProblem"
      }
    }, [_vm._v("\n                        Log Problem\n                    ")]), _vm._v(" "), _c('md-switch', {
      attrs: {
        "id": "log-result",
        "name": "log-result"
      },
      model: {
        value: (_vm.newAlgData.logResult),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "logResult", $$v)
        },
        expression: "newAlgData.logResult"
      }
    }, [_vm._v("\n                        Log Result\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-switch', {
      attrs: {
        "id": "log-to-pythia",
        "name": "log-to-pythia"
      },
      model: {
        value: (_vm.newAlgData.logToPythia),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "logToPythia", $$v)
        },
        expression: "newAlgData.logToPythia"
      }
    }, [_vm._v("\n                        Log To Pythia\n                    ")]), _vm._v(" "), _c('md-switch', {
      attrs: {
        "id": "watched",
        "name": "log-problem"
      },
      model: {
        value: (_vm.newAlgData.watched),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "watched", $$v)
        },
        expression: "newAlgData.watched"
      }
    }, [_vm._v("\n                        Watched\n                    ")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "id": "userAudiences",
        "options": _vm.customerTags,
        "multiple": true,
        "taggable": true,
        "placeholder": "Customer Tag"
      },
      on: {
        "tag": _vm.addTag,
        "remove": _vm.removeTag
      },
      model: {
        value: (_vm.newAlgData.customerTag),
        callback: function($$v) {
          _vm.$set(_vm.newAlgData, "customerTag", $$v)
        },
        expression: "newAlgData.customerTag"
      }
    })]
  ], 2) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeAdditionalDialog(false, 'baas')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.baasValidMessage && Object.keys(_vm.baasValidMessage).length > 0
    },
    on: {
      "click": function($event) {
        return _vm.closeAdditionalDialog(true, 'baas')
      }
    }
  }, [_vm._v("Create\n            ")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "maasDialog"
  }, [_c('md-dialog-title', [_vm._v("Register at maas service")]), _vm._v(" "), _c('md-dialog-content', [(_vm.app) ? _c('form', [_c('div', [_c('md-switch', {
    attrs: {
      "id": "configureManually",
      "name": "configureManually"
    },
    model: {
      value: (_vm.app.configureManually),
      callback: function($$v) {
        _vm.$set(_vm.app, "configureManually", $$v)
      },
      expression: "app.configureManually"
    }
  }, [_vm._v("\n                        Configure manually\n                    ")])], 1), _vm._v(" "), (_vm.services) ? _c('multiselect', {
    attrs: {
      "id": "services",
      "disabled": _vm.app.configureManually,
      "options": _vm.services,
      "label": 'name',
      "placeholder": "Select service"
    },
    model: {
      value: (_vm.app.selectedService),
      callback: function($$v) {
        _vm.$set(_vm.app, "selectedService", $$v)
      },
      expression: "app.selectedService"
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeAdditionalDialog(false, 'maas')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeAdditionalDialog(true, 'maas')
      }
    }
  }, [_vm._v("Create")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03296468!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTabs/AdminApps.vue
// module id = 295
// module chunks = 2